import React, { createContext, useContext, useMemo } from "react";

export const FULL_ACCESS_GROUP = "artist-share-lists@max.live";
export const LIMITED_ACCESS_CLAIM = "sharelist_limited";

export type AccessType = "full" | "limited" | "none";

interface AccessContextProps {
  type: AccessType;
}

// default to the most restrictive access level
export const AccessContext = createContext<AccessContextProps>({
  type: "none",
});

export const AccessProvider = ({
  type,
  children,
}: {
  type: AccessType;
  children: React.ReactNode;
}) => {
  const value = useMemo(() => ({ type }), [type]);

  return (
    <AccessContext.Provider value={value}>{children}</AccessContext.Provider>
  );
};

export const useAccess = () => useContext(AccessContext);
